import { ComponentPropsWithoutRef } from 'react';
import { DropdownMenu } from 'radix-ui';

import { cn } from '@components/primitives/utilities';

import styles from './styles.module.css';

export type MenuRadioItemProps = ComponentPropsWithoutRef<
  typeof DropdownMenu.RadioItem
>;

export function MenuRadioItem({
  className,
  children,
  ...props
}: MenuRadioItemProps) {
  return (
    <DropdownMenu.RadioItem
      className={cn(styles.menuItem, className)}
      {...props}
    >
      <div className={styles.dot} />
      <span className={styles.label}>{children}</span>
    </DropdownMenu.RadioItem>
  );
}
